export let tinymce = window['tinymce'];


// WEBPACK FOOTER //
// ./source/ts/helpers/tinymce.ts